import React from 'react'
import Mob_login_two from '../../components/mobile_view_comp/login_two/mob_login_two'

export default function Login_two() {
  return (
    <>
        <Mob_login_two />
    </>
  )
}